import h from "../services/h";
import departmentService from "../services/departmentService";
import constants from "../constants";
import utils from "../services/utils";
// import utils from "../services/utils";

export default {
  data() {
    return {
      userDeptRoleHandlers: [],
      departmentHandlers: [],
      roots: [],
      handlerOrderMap: {} //map id (userDeptRoleId || deptId) vs cáu hình bước tiếp theo;
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    getOrderByHandlerId(id) {
      return this.handlerOrderMap ? this.handlerOrderMap[id] : null;
    },

    getOrderOfHandlerNode(node) {
      let id = null;
      switch (node.nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          id = node.department.id;
          break;
        case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
          id = node.userDeptRole.id;
          break;
      }
      if (!id) return null;
      return this.getOrderByHandlerId(id);
    },
    buildNodesForLongUri() {
      if (this.userDeptRoleHandlers) {
        this.userDeptRoleHandlers.sort((item1, item2) =>
          utils.compareUserDeptRoleView(item1, item2)
        );
      }

      if (this.departmentHandlers) {
        this.departmentHandlers.sort((item1, item2) =>
          utils.compareDepartment(item1, item2)
        );
      }

      this.roots = [];
      let departmentsIds = h.collect(
        this.departmentHandlers,
        department => department.id
      );
      let departmentsParentIds = h.collect(
        this.departmentHandlers,
        department => department.parentId
      );
      let userDeptRolesDeptIds = h.collect(
        this.userDeptRoleHandlers,
        userDeptRole => userDeptRole.deptId
      );
      let departmentIdsSet = [];
      h.each(
        departmentsIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      h.each(
        departmentsParentIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      h.each(
        userDeptRolesDeptIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      return (departmentIdsSet && departmentIdsSet.length
          ? this.loadDepartmentsPost(departmentIdsSet)
          : Promise.resolve([])
      ).then(allDepartments => {
        h.each(allDepartments, department => {
          let isRoot =
            h.indexOf(
              allDepartments,
              parentDepartment => parentDepartment.id === department.parentId
            ) === -1;
          isRoot && this.roots.push(this.initNodeForDept({}, department));
        });

        let nodes = [];
        nodes.push(...this.roots);
        let index = 0;
        while (index < nodes.length) {
          let node = nodes[index];
          if (node.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
            let department = node.department;

            let subUserDeptRoles =
              h.findAll(
                this.userDeptRoleHandlers,
                userDeptRole => userDeptRole.deptId === department.id
              ) || [];

            let userDeptRoleChildNodes = h.collect(
              subUserDeptRoles,
              subUserDeptRole =>
                this.initNodeForUserDeptRole({}, subUserDeptRole)
            );

            let subDepartments =
              h.findAll(
                allDepartments,
                subDepartment => subDepartment.parentId === department.id
              ) || [];

            let departmentChildNodes = h.collect(
              subDepartments,
              subDepartment => this.initNodeForDept({}, subDepartment)
            );

            let childNodes = [];
            userDeptRoleChildNodes &&
            childNodes.push(...userDeptRoleChildNodes);
            departmentChildNodes && childNodes.push(...departmentChildNodes);

            nodes.push(...childNodes);
            this.setParentChildren(node, childNodes);
          }
          index++;
        }
        h.each(this.roots, root => this.hieuChinhTreeByOrder(root));
        h.each(this.roots, root => this.hieuChinhTree(root));
      });
    },
    buildNodes() {
      // console.log('Start build nodes ...')
      // console.log('this.userDeptRoleHandlers:', this.userDeptRoleHandlers)
      if (this.userDeptRoleHandlers) {
        this.userDeptRoleHandlers.sort((item1, item2) =>
          utils.compareUserDeptRoleView(item1, item2)
        );
      }

      // console.log('this.departmentHandlers:', this.departmentHandlers)
      if (this.departmentHandlers) {
        this.departmentHandlers.sort((item1, item2) =>
          utils.compareDepartment(item1, item2)
        );
      }

      this.roots = [];
      let departmentsIds = h.collect(
        this.departmentHandlers,
        department => department.id
      );
      // console.log('departmentsIds:', departmentsIds)

      let departmentsParentIds = h.collect(
        this.departmentHandlers,
        department => department.parentId
      );
      // console.log('departmentsParentIds:', departmentsParentIds)

      let userDeptRolesDeptIds = h.collect(
        this.userDeptRoleHandlers,
        userDeptRole => userDeptRole.deptId
      );
      // console.log('userDeptRolesDeptIds:', userDeptRolesDeptIds)

      let departmentIdsSet = [];
      h.each(
        departmentsIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      h.each(
        departmentsParentIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      h.each(
        userDeptRolesDeptIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      // console.log('departmentIdsSet:', departmentIdsSet)
      return (departmentIdsSet && departmentIdsSet.length
          ? this.loadDepartments(departmentIdsSet)
          : Promise.resolve([])
      ).then(allDepartments => {
        h.each(allDepartments, department => {
          let isRoot =
            h.indexOf(
              allDepartments,
              parentDepartment => parentDepartment.id === department.parentId
            ) === -1;
          isRoot && this.roots.push(this.initNodeForDept({}, department));
        });

        let nodes = [];
        nodes.push(...this.roots);
        let index = 0;
        while (index < nodes.length) {
          let node = nodes[index];
          if (node.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
            let department = node.department;

            let subUserDeptRoles =
              h.findAll(
                this.userDeptRoleHandlers,
                userDeptRole => userDeptRole.deptId === department.id
              ) || [];

            let userDeptRoleChildNodes = h.collect(
              subUserDeptRoles,
              subUserDeptRole =>
                this.initNodeForUserDeptRole({}, subUserDeptRole)
            );

            let subDepartments =
              h.findAll(
                allDepartments,
                subDepartment => subDepartment.parentId === department.id
              ) || [];

            let departmentChildNodes = h.collect(
              subDepartments,
              subDepartment => this.initNodeForDept({}, subDepartment)
            );

            let childNodes = [];
            userDeptRoleChildNodes &&
            childNodes.push(...userDeptRoleChildNodes);
            departmentChildNodes && childNodes.push(...departmentChildNodes);

            nodes.push(...childNodes);
            this.setParentChildren(node, childNodes);
          }
          index++;
        }
        h.each(this.roots, root => this.hieuChinhTreeByOrder(root));
        h.each(this.roots, root => this.hieuChinhTree(root));
        // console.log('End build nodes.')
      });
    },
    buildNodesMergeHDTVandTCTForVinataba() {
      // console.log('Start build nodes ...')
      // console.log('this.userDeptRoleHandlers:', this.userDeptRoleHandlers)
      if (this.userDeptRoleHandlers) {
        this.userDeptRoleHandlers.sort((item1, item2) =>
          utils.compareUserDeptRoleView(item1, item2)
        );
      }

      // console.log('this.departmentHandlers:', this.departmentHandlers)
      if (this.departmentHandlers) {
        this.departmentHandlers.sort((item1, item2) =>
          utils.compareDepartment(item1, item2)
        );
      }

      this.roots = [];
      let departmentsIds = h.collect(
        this.departmentHandlers,
        department => department.id
      );
      // console.log('departmentsIds:', departmentsIds)

      let departmentsParentIds = h.collect(
        this.departmentHandlers,
        department => department.parentId
      );
      // console.log('departmentsParentIds:', departmentsParentIds)

      let userDeptRolesDeptIds = h.collect(
        this.userDeptRoleHandlers,
        userDeptRole => userDeptRole.deptId
      );
      // console.log('userDeptRolesDeptIds:', userDeptRolesDeptIds)

      let departmentIdsSet = [];
      h.each(
        departmentsIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      h.each(
        departmentsParentIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      h.each(
        userDeptRolesDeptIds,
        id => departmentIdsSet.indexOf(id) === -1 && departmentIdsSet.push(id)
      );
      // console.log('departmentIdsSet:', departmentIdsSet)
      return (departmentIdsSet && departmentIdsSet.length
          ? this.loadDepartments(departmentIdsSet)
          : Promise.resolve([])
      ).then(allDepartments => {
        h.each(allDepartments, department => {
          let isRoot =
            h.indexOf(
              allDepartments,
              parentDepartment => parentDepartment.id === department.parentId
            ) === -1;
          isRoot && this.roots.push(this.initNodeForDept({}, department));
        });

        let nodes = [];
        nodes.push(...this.roots);
        let index = 0;
        while (index < nodes.length) {
          let node = nodes[index];
          if (node.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT) {
            let department = node.department;

            let subUserDeptRoles =
              h.findAll(
                this.userDeptRoleHandlers,
                userDeptRole => userDeptRole.deptId === department.id
              ) || [];

            let userDeptRoleChildNodes = h.collect(
              subUserDeptRoles,
              subUserDeptRole =>
                this.initNodeForUserDeptRole({}, subUserDeptRole)
            );

            let subDepartments =
              h.findAll(
                allDepartments,
                subDepartment => subDepartment.parentId === department.id
              ) || [];

            let departmentChildNodes = h.collect(
              subDepartments,
              subDepartment => this.initNodeForDept({}, subDepartment)
            );

            let childNodes = [];
            userDeptRoleChildNodes &&
            childNodes.push(...userDeptRoleChildNodes);
            departmentChildNodes && childNodes.push(...departmentChildNodes);

            nodes.push(...childNodes);
            this.setParentChildren(node, childNodes);
          }
          index++;
        }
        h.each(this.roots, root => this.hieuChinhTreeByOrder(root));
        h.each(this.roots, root => this.hieuChinhTreeMergeHDTVandTCTForVinataba(root));
        // console.log('End build nodes.')
      });
    },

    setParentChildren(node, childNodes) {
      this.$set(node, "children", childNodes);
      h.each(childNodes, childNode => this.$set(childNode, "parent", node));
      if(node.children.length !== 0) {
        this.$set(node, "isHandlerNode", false);
      }
    },

    hieuChinhTreeByOrder(data) {
      if (data.children) {
        data.children.sort((childNode1, childNode2) => {
          return this.compareNode(childNode1, childNode2);
          // return (
          //   (this.getOrderOfHandlerNode(childNode1) || 1000) -
          //   (this.getOrderOfHandlerNode(childNode2) || 1000)
          // );
        });
        h.each(data.children, childNode =>
          this.hieuChinhTreeByOrder(childNode)
        );
      }
    },

    compareNode(node1, node2) {
      let node1Type = node1.nodeType;
      let node2Type = node2.nodeType;
      if (node1Type === node2Type) {
        let compareResult;
        switch (node1Type) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            compareResult =
              (this.getOrderOfHandlerNode(node1) || 1000) -
              (this.getOrderOfHandlerNode(node2) || 1000);
            if (compareResult !== 0) return compareResult;
            else
              return utils.compareUserDeptRoleView(
                node1.userDeptRole,
                node2.userDeptRole
              );
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            compareResult =
              (this.getOrderOfHandlerNode(node1) || 1000) -
              (this.getOrderOfHandlerNode(node2) || 1000);
            if (compareResult !== 0) return compareResult;
            else
              return utils.compareDepartment(
                node1.department,
                node2.department
              );
          default:
            return 0;
        }
      } else {
        return 0;
      }
    },

    /**
     * bo sung cac node PBCN, DVTT, PBCNAndDVTT ...
     */
    hieuChinhTree(data) {
      switch (data.nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          let department = data.department;
          if (department.deptCode === this.$store.getters.globalRoles) {
            let childNodes = [];

            //build node HDTV
            let duNode = h.find(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptCode === constants.DANG_UY_TCT_DEPT_CODE
            );
            if (duNode) childNodes.push(duNode);

            //build node HDTV
            let hdtvNode = h.find(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptCode === constants.HDTV_DEPT_CODE
            );
            if (hdtvNode) childNodes.push(hdtvNode);

            //build node Ban TGD
            let banTGDNodes = h.findAll(
              data.children,
              child =>
                child.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
                child.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
            );
            if (banTGDNodes && banTGDNodes.length)
              if(this.user && this.user.tenantCode === 'cmsc.gov.vn'){
                childNodes.push(this.initNodeCustom({}, banTGDNodes));
              } else {
                if(this.$store.getters.user.tenantCode === 'vinatabatrading.com.vn'){
                  childNodes.push(...banTGDNodes);
                }else {
                  childNodes.push(this.initNodeForBanTGDNode({}, banTGDNodes));
                }
              }

            //build node PBCNAndDVTT
            let pbcnNodes = h.findAll(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptType ===
                constants.DEPARTMENT.DEPT_TYPE.PBCN
            );
            let dvttNodes = h.findAll(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptType ===
                constants.DEPARTMENT.DEPT_TYPE.DVTT
            );

            if (
              (pbcnNodes && pbcnNodes.length) ||
              (dvttNodes && dvttNodes.length)
            )
              childNodes.push(
                this.initNodeForPBCNAndDVTT({}, pbcnNodes, dvttNodes)
              );

            // co the co cac node khac > build nhung node con sot lai;
            let otherNodes = h.findAll(
              data.children,
              childNode =>
                (!banTGDNodes || banTGDNodes.indexOf(childNode) === -1) &&
                hdtvNode !== childNode &&
                duNode !== childNode &&
                (!pbcnNodes || pbcnNodes.indexOf(childNode) === -1) &&
                (!dvttNodes || dvttNodes.indexOf(childNode) === -1)
            );

            if (otherNodes && otherNodes.length) childNodes.push(...otherNodes);
            this.setParentChildren(data, childNodes);
          } else {
            let childNodes = [];

            let caNhanNodes = h.findAll(
              data.children,
              child =>
                child.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
            );
            // if (caNhanNodes) {
            //   caNhanNodes = caNhanNodes.sort((node1, node2) =>
            //     utils.compareUserDeptRoleView(
            //       node1.userDeptRole,
            //       node2.userDeptRole
            //     )
            //   );
            // }

            let donviNodes = h.findAll(
              data.children,
              child =>
                child.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT
            );
            // if (donviNodes) {
            //   donviNodes = donviNodes.sort((node1, node2) =>
            //     utils.compareDepartment(node1.department, node2.department)
            //   );
            // }

            let otherNodes = h.findAll(
              data.children,
              child =>
                (!caNhanNodes || caNhanNodes.indexOf(child) === -1) &&
                (!donviNodes || donviNodes.indexOf(child) === -1)
            );

            if (caNhanNodes) childNodes.push(...caNhanNodes);
            if (donviNodes) childNodes.push(...donviNodes);
            if (otherNodes) childNodes.push(...otherNodes);

            this.setParentChildren(data, childNodes);
          }
          break;
        default:
          break;
      }

      h.each(data.children, childNode => this.hieuChinhTree(childNode));
    },

    hieuChinhTreeMergeHDTVandTCTForVinataba(data) {
      switch (data.nodeType) {
        case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
          let department = data.department;
          if (department.deptCode === this.$store.getters.globalRoles) {
            let childNodes = [];

            //build node DU
            let duNode = h.find(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptCode === constants.DANG_UY_TCT_DEPT_CODE
            );
            if (duNode) childNodes.push(duNode);

            //build node HDTV + Ban TGD -> Lanh Dao TCT
            let hdtvNode = h.find(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptCode === constants.HDTV_DEPT_CODE
            );

            //build node TTDU
            let ttduNode = h.find(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptCode === constants.TTDUTCT_DEPT_CODE
            );

            //build node Ban TGD
            let banTGDNodes = h.findAll(
              data.children,
              child =>
                child.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE &&
                child.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
            );
            if (banTGDNodes && banTGDNodes.length)
              childNodes.push(this.initNodeForBanTGDNodeVinataba({}, banTGDNodes, hdtvNode, ttduNode));
            //build node PBCNAndDVTT
            let pbcnNodes = h.findAll(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptType ===
                constants.DEPARTMENT.DEPT_TYPE.PBCN
            );
            let dvttNodes = h.findAll(
              data.children,
              childNode =>
                childNode.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.DEPT &&
                childNode.department.deptType ===
                constants.DEPARTMENT.DEPT_TYPE.DVTT
            );

            if (
              (pbcnNodes && pbcnNodes.length) ||
              (dvttNodes && dvttNodes.length)
            )
              childNodes.push(
                this.initNodeForPBCNAndDVTT({}, pbcnNodes, dvttNodes)
              );
            // co the co cac node khac > build nhung node con sot lai;
            let otherNodes = h.findAll(
              data.children,
              childNode =>
                (!banTGDNodes || banTGDNodes.indexOf(childNode) === -1) &&
                duNode !== childNode &&
                hdtvNode !== childNode &&
                ttduNode !== childNode &&
                (!pbcnNodes || pbcnNodes.indexOf(childNode) === -1) &&
                (!dvttNodes || dvttNodes.indexOf(childNode) === -1)
            );

            if (otherNodes && otherNodes.length) childNodes.push(...otherNodes);
            this.setParentChildren(data, childNodes);
          } else {
            let childNodes = [];

            let caNhanNodes = h.findAll(
              data.children,
              child =>
                child.nodeType ===
                constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
            );
            // if (caNhanNodes) {
            //   caNhanNodes = caNhanNodes.sort((node1, node2) =>
            //     utils.compareUserDeptRoleView(
            //       node1.userDeptRole,
            //       node2.userDeptRole
            //     )
            //   );
            // }

            let donviNodes = h.findAll(
              data.children,
              child =>
                child.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT
            );
            // if (donviNodes) {
            //   donviNodes = donviNodes.sort((node1, node2) =>
            //     utils.compareDepartment(node1.department, node2.department)
            //   );
            // }

            let otherNodes = h.findAll(
              data.children,
              child =>
                (!caNhanNodes || caNhanNodes.indexOf(child) === -1) &&
                (!donviNodes || donviNodes.indexOf(child) === -1)
            );

            if (caNhanNodes) childNodes.push(...caNhanNodes);
            if (donviNodes) childNodes.push(...donviNodes);
            if (otherNodes) childNodes.push(...otherNodes);
            this.setParentChildren(data, childNodes);
          }
          break;
        default:
          break;
      }
      h.each(data.children, childNode => this.hieuChinhTree(childNode));
    },
    initNodeForPBCNAndDVTT(node, pbcnNodes, dvttNodes) {
      let childNodes = [];
      if (pbcnNodes && pbcnNodes.length)
        childNodes.push(this.initNodeForPBCN({}, pbcnNodes));
      if (dvttNodes && dvttNodes.length)
        childNodes.push(this.initNodeForDVTT({}, dvttNodes));
      this.$set(node, "id", constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT);
      this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.PBCNAndDVTT);
      this.setParentChildren(node, childNodes);
      return node;
    },

    initNodeForPBCN(node, pbcnNodes) {
      // pbcnNodes = pbcnNodes.sort((node1, node2) =>
      //   utils.compareDepartment(node1.department, node2.department)
      // );
      this.$set(node, "id", constants.DEPARTMENT_TREE.NODE_TYPE.PBCN);
      this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.PBCN);
      this.setParentChildren(node, pbcnNodes);
      return node;
    },

    initNodeForDVTT(node, dvttNodes) {
      // dvttNodes = dvttNodes.sort((node1, node2) =>
      //   utils.compareDepartment(node1.department, node2.department)
      // );
      this.$set(node, "id", constants.DEPARTMENT_TREE.NODE_TYPE.DVTT);
      this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.DVTT);
      this.setParentChildren(node, dvttNodes);
      return node;
    },

    initNodeForBanTGDNode(node, banTGDNodes) {
      // banTGDNodes = banTGDNodes.sort((node1, node2) =>
      //   utils.compareUserDeptRoleView(node1.userDeptRole, node2.userDeptRole)
      // );
      this.$set(node, "id", constants.DEPARTMENT_TREE.NODE_TYPE.BTGD);
      this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.BTGD);
      this.setParentChildren(node, banTGDNodes);
      return node;
    },

    initNodeCustom(node, banTGDNodes) {
      // banTGDNodes = banTGDNodes.sort((node1, node2) =>
      //   utils.compareUserDeptRoleView(node1.userDeptRole, node2.userDeptRole)
      // );
      this.$set(node, "id", constants.DEPARTMENT_TREE.NODE_TYPE.CUSTOM);
      this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.CUSTOM);
      this.setParentChildren(node, banTGDNodes);
      return node;
    },

    initNodeForBanTGDNodeVinataba(node, banTGDNodes, HDTVNodes, ttduNode){
      banTGDNodes.push(...HDTVNodes.children, ...ttduNode.children)
      this.$set(node, "id", constants.DEPARTMENT_TREE.NODE_TYPE.LANHDAO_TCT);
      this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.LANHDAO_TCT);
      this.setParentChildren(node, banTGDNodes);
      return node;
    },

    initNodeForDept(node, department) {
      this.$set(node, "id", department.id);
      this.$set(node, "department", department);
      this.$set(node, "nodeType", constants.DEPARTMENT_TREE.NODE_TYPE.DEPT);
      this.$set(
        node,
        "isHandlerNode",
        h.exists(this.departmentHandlers, item => item.id === department.id)
      );
      return node;
    },

    initNodeForUserDeptRole(node, userDeptRole) {
      this.$set(node, "id", userDeptRole.id);
      this.$set(node, "userDeptRole", userDeptRole);
      this.$set(node, "isHandlerNode", true);
      this.$set(
        node,
        "nodeType",
        constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
      );
      return node;
    },

    loadDepartments(departmentIdsSet) {
      return departmentService
        .findAllByIdIn(departmentIdsSet, constants.DEPARTMENT.STATUS.ACTIVE)
        .then(response => response.data);
    },

    loadDepartmentsPost(departmentIdsSet) {
      return departmentService
        .findAllByIdInPost(departmentIdsSet, constants.DEPARTMENT.STATUS.ACTIVE)
        .then(response => response.data);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/handlersTreeMixin.js